module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<a class="return-to-editor btn btn-primary">Return to Dashboard</a>\n<a class="create-experience btn btn-primary">Create Experience</a>\n<div class="preview-region">\n    <div class="zoom-region"></div>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/viewer/PreviewTemplateNavBarView.tpl
// module id = 3041
// module chunks = 0